import React from 'react';
import {entity as letterSnippets} from '../../ducks/letterSnippets';
import SnippetList from './SnippetList';
import LetterSnippetEditor from './LetterSnippetEditor';
import {tags} from "../../ducks";
import {withSnippetFunctions} from "./snippetUtils";
import duckify, {filterDuck} from "../../utils/duckify";
import {compose} from "redux";
import {withRouter} from "react-router";
import withFiltering from "../../hocs/withFiltering";
import withTagging from "../../hocs/withTagging";

const LetterSnippetList = (props) => {
  const {
    items,
    ...extraprops
  } = props

  return <SnippetList
    displayName="Letter"
    editModal={LetterSnippetEditor}
    type="letter"
    items={items}
    {...extraprops}
  />;
};

const mapDucksToProps = ({filters}) => ({
  items: filterDuck(letterSnippets, {filters}),
  tags,
});

export default compose(
  withRouter,
  withFiltering,
  withTagging(letterSnippets),
  withSnippetFunctions(letterSnippets),
  duckify(mapDucksToProps)
)(LetterSnippetList);
